<template>
  <div class="wrap">
    <h1 class="common-header">{{ $t('311') }}</h1>
    <!-- 内容 -->
    <div class="by-content">
      <el-form
        :model="currentCompany"
        label-position="top"
        ref="currentForm"
        label-width="100px"
        class="by-content-body"
      >
        <!-- <el-form :model="currentCompany" :rules="rules" ref="ruleForm" label-width="100px" class="by-content-body"> -->
        <h1 class="by-list-title">{{ $t('312') }}</h1>
        <div class="modify-wrap" v-if="$p('menu.settings.settings_company_manager.edit')">
          <el-button v-if="!saveState" type="primary" plain @click="saveState = true">{{ $t('419') }}</el-button>
          <template v-else>
            <el-button type="primary" plain @click="saveState = false">{{ $t('66') }}</el-button>
            <el-button type="primary" plain @click="modifyBaseInfo">{{ $t('67') }}</el-button>
          </template>
        </div>
        <div class="baseinfo-wrap">
          <div>
            <div class="baseinfo-logo">
              <upload
                v-if="saveState"
                ref="upload"
                :disabled="!saveState"
                listType="picture"
                :file-limit="1"
                :show-btn="false"
                :show-file="false"
                :file-format="fileFormat"
                @success="uploadSuccess"
              />
              <img :src="currentCompany.logo_url" />
              <p v-if="saveState" class="bottom-tip">{{ $t('313') }}</p>
            </div>
            <div class="baseinfo-name">
              <p class="label-name">{{ $t('314') }}</p>
              <el-input
                :disabled="!saveState"
                style="width: 300px"
                v-model="currentCompany.name"
                :placeholder="$t('314')"
              ></el-input>
            </div>
          </div>
          <div>
            <el-form-item class="base-form-wrap" :label="$t('0164ef18')" prop="industry">
              <el-select v-model="currentCompany.currency" :placeholder="$t('259')" :disabled="!saveState">
                <el-option label="THB" value="THB"></el-option>
                <el-option label="IDR" value="IDR"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <p v-if="saveState" style="padding: 10px 0 0; color: red">{{ $t('1698') }}</p>
        <!-- 基本信息 -->
        <div class="base-authentication">
          <!-- 行业 -->
          <el-form-item class="base-form-wrap" :label="$t('316')" prop="industry">
            <el-select v-model="currentCompany.industry" :placeholder="$t('259')" :disabled="!saveState">
              <el-option v-for="(item, key, index) in industries" :key="index" :label="item" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <!-- 规模 -->
          <el-form-item class="base-form-wrap" :label="$t('317')" prop="size">
            <el-select v-model="currentCompany.size" :placeholder="$t('260')" :disabled="!saveState">
              <el-option v-for="(item, key, index) in size" :key="index" :label="item" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <!--纳税人姓名 -->
          <el-form-item class="base-form-wrap" :label="$t('1044')" prop="taxpayer">
            <el-input
              v-model="currentCompany.taxpayer"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              max="50"
            />
          </el-form-item>
          <!--商业代码 -->
          <el-form-item class="base-form-wrap" :label="$t('1041')" prop="business_code">
            <el-input
              v-model="currentCompany.business_code"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
            />
          </el-form-item>
          <!--纳税人账户 -->
          <el-form-item class="base-form-wrap" :label="$t('1046')" prop="taxpayer_account">
            <el-input
              v-model="currentCompany.taxpayer_account"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
            />
          </el-form-item>
          <!--传真 -->
          <el-form-item class="base-form-wrap" :label="$t('1043')" prop="fax">
            <el-input
              v-model="currentCompany.fax"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              @input="currentCompany.fax = currentCompany.fax.replace(/[^\d]/g, '')"
            />
          </el-form-item>
          <!--纳税人手机号 -->
          <el-form-item class="base-form-wrap" :label="$t('1045')" prop="taxpayer_mobile">
            <el-input
              v-model="currentCompany.taxpayer_mobile"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              @input="currentCompany.taxpayer_mobile = currentCompany.taxpayer_mobile.replace(/[^\d]/g, '')"
            />
          </el-form-item>

          <!--分支机构编号 -->
          <el-form-item class="base-form-wrap" :label="$t('1240')" prop="branch_no">
            <el-input
              v-model="currentCompany.branch_no"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              :maxlength="5"
            />
          </el-form-item>

          <!--单位社保编号 -->
          <el-form-item class="base-form-wrap" :label="$t('1039')" prop="social_number">
            <el-input
              v-model="currentCompany.social_number"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              :maxlength="10"
            />
          </el-form-item>
          <!--网点编号 -->
          <el-form-item class="base-form-wrap" :label="$t('1310')" prop="outlet_number">
            <el-input
              v-model="currentCompany.outlet_number"
              :placeholder="saveState ? $t('please_enter_message') : $t('1257')"
              :disabled="!saveState"
              :maxlength="6"
            />
          </el-form-item>
          <!--公司地址（泰） -->
          <template v-if="saveState">
            <p class="label-title">
              {{ $t('1040') }}
            </p>
            <el-form-item
              class="base-form-wrap"
              v-for="(item, index) in companyAdd"
              :key="index"
              :label="item.label"
              :prop="item.value"
              :rules="[{ required: item.required, message: $t('1593') }]"
            >
              <el-input
                v-model="currentCompany[item.value]"
                :placeholder="$t('please_enter_message')"
                :maxlength="item.maxlength"
              />
            </el-form-item>
          </template>
          <el-form-item class="base-form-wrap base-form-wrap-100" :label="$t('1040')" prop="address" v-else>
            <span>{{ currentCompany.address }}</span>
          </el-form-item>
          <!--公司地址（英） -->
          <p class="label-title" v-if="saveState">
            {{ $t('i18n.645bc12941a24d4a9f4c4579d71b13a9') }}
            <i :class="[isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'icon']" @click="handleShow" />
          </p>
          <template v-if="saveState && isShow">
            <el-form-item
              class="base-form-wrap"
              v-for="(item, index) in companyAddEn"
              :key="index + '_en'"
              :label="item.label"
              :prop="item.value"
            >
              <el-input
                v-model="currentCompany[item.value]"
                :placeholder="$t('please_enter_message')"
                :maxlength="item.maxlength"
              />
            </el-form-item>
          </template>
          <el-form-item
            class="base-form-wrap base-form-wrap-100"
            :label="$t('i18n.645bc12941a24d4a9f4c4579d71b13a9')"
            prop="address_en"
            v-if="!saveState"
          >
            <span>{{ currentCompany.address_en }}</span>
          </el-form-item>
        </div>
        <!-- 更换主管理员 -->
        <div class="replace-manager">
          <template v-if="currentCompany.is_sa">
            <h1 class="by-list-title">{{ $t('325') }}</h1>
            <p class="replace-tip tip">{{ $t('326') }}</p>
          </template>
          <div class="current-manager" :style="{ paddingTop: currentCompany.is_sa ? '0px' : '20px' }">
            <div class="current-list">
              <p>
                <span>{{ $t('327') }}：</span>
                <span>
                  {{ currentCompany.sa_info ? currentCompany.sa_info.name : '' }}
                </span>
              </p>
            </div>
            <div class="current-list">
              <p>
                <span>{{ $t('320') }}</span>
                <span>
                  {{ currentCompany.sa_info ? currentCompany.sa_info.mobile : '' }}
                </span>
              </p>
              <!-- 转移权限 -->
              <el-button
                v-if="currentCompany.is_sa && $p('menu.settings.settings_company_manager.edit')"
                type="primary"
                plain
                class="transfo"
                @click="openReplace"
                >{{ $t('328') }}</el-button
              >
            </div>
          </div>
        </div>
        <!-- 分割线 -->
        <el-divider v-if="currentCompany.is_sa"></el-divider>
        <!-- 企业认证 -->
        <div class="base-authentication" v-if="currentCompany.is_sa">
          <h1 class="by-list-title">
            {{ $t('1200') }}
            <span class="explain" v-if="Number(company_info.audit_status) !== 2"> {{ $t('1210') }}</span>
          </h1>
          <p class="audit-status">{{ $t('1202') }}：{{ auditStatusType }}</p>
          <el-form :model="form" :rules="rules" ref="form" class="base-form-wrap">
            <!-- 企业名称 -->
            <el-form-item prop="c_name">
              <p class="label-title">{{ $t('314') }}</p>
              <el-input :disabled="disabled" v-model="form.c_name" :placeholder="$t('314')"></el-input>
            </el-form-item>
            <!-- 营业执照 -->
            <el-form-item prop="c_license">
              <p class="label-title">{{ $t('1207') }}</p>
              <el-input
                :disabled="disabled"
                v-model="form.c_license"
                :placeholder="$t('1207')"
                v-enterIntNumber
                v-enterNumberMax="99999999999999999998"
              ></el-input>
            </el-form-item>
          </el-form>
          <br />
          <!-- 提交审核 -->
          <el-button type="primary" plain @click="saveAudit" :disabled="disabled" v-if="$p('menu.settings.settings_company_manager.edit')">{{
            $t('1208')
          }}</el-button>
        </div>
        <!-- 分割线 -->
        <el-divider v-if="currentCompany.is_sa"></el-divider>
        <!-- 高级设置 -->
        <div class="senior" v-if="currentCompany.is_sa">
          <h1 class="by-list-title">{{ $t('332') }}</h1>
          <p class="tip">
            {{ $t('333') }}
            <br />
            {{ $t('335') }}
          </p>
          <br />
          <!-- 解散企业 -->
          <el-button type="danger" plain @click="handleDismissCompany" v-if="$p('menu.settings.settings_company_manager.delete')">{{
            $t('333')
          }}</el-button>
        </div>
      </el-form>
    </div>
    <!-- 更换管理员 -->
    <replace-manger ref="replace" />
  </div>
</template>

<script>
import '@/views/payroll/directive.js'
import { mapState } from 'vuex'
// 更换管理员
import ReplaceManger from './modal/replace-manager'
import upload from '@/components/upload'
// 接口api
import { dismissCompany, modifybase, saveAudit } from 'api/settings'
import { companyIndustries, companySize } from 'api/login'
import { utilCookies } from '@/util/cookies'
import { companyAdd, companyAddEn } from './config'
import { currentSession } from 'api/common'

const auditStatus = $t =>
  new Map([
    [0, $t('1203')], // 未提交
    [1, $t('1204')], // 待审核
    [2, $t('1206')], // 已通过
    [3, $t('1205')] // 已拒绝
  ])

export default {
  components: {
    ReplaceManger,
    upload
  },
  data() {
    return {
      saveState: false,
      // 是否修改
      modifyState: true,
      // 行业列表
      industries: [],
      // 规模列表
      size: [],
      currentCompany: {
        sa_info: {}
      },
      fileFormat: ['.png', '.jpg', '.jpeg'],
      // 认证状态
      auditStatus: auditStatus(this.$t),
      // form
      form: {
        c_name: '',
        c_license: ''
      },
      rules: {
        c_name: [{ required: true, message: this.$t('314'), trigger: 'blur' }],
        c_license: [{ required: true, message: this.$t('1207'), trigger: 'blur' }]
      },
      companyAdd: companyAdd(this),
      companyAddEn: companyAddEn(this),
      isShow: false
    }
  },
  computed: {
    ...mapState({
      company_info: state => state.user.company_info
    }),
    // 认证状态文案
    auditStatusType() {
      return this.auditStatus.get(Number(this.company_info.audit_status))
    },
    // 是否可以提交认证
    disabled() {
      const status = Number(this.company_info.audit_status)
      return status === 1 || status === 2
    }
  },
  created() {
    // 行业
    companyIndustries().then(res => {
      this.industries = res.data
    })
    // 规模
    companySize().then(res => {
      this.size = res.data
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.currentCompany = this.$s.get('currentCompany')
      console.log(this.currentCompany)
      this.form = this.currentCompany.audit_info
    },
    openReplace() {
      this.$refs.replace.init(true, this.currentCompany.sa_info ? this.currentCompany.sa_info.mobile : '')
    },
    changeState() {
      this.modifyState = !this.modifyState
    },
    handleShow() {
      this.isShow = !this.isShow
    },
    // 解散公司
    handleDismissCompany() {
      this.$confirm(this.$t('824'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        dismissCompany().then(() => {
          utilCookies.removeToken()
          utilCookies.removeCompanyToken()
          window.location.reload()
        })
      })
    },
    // 修改基础信息
    modifyBaseInfo() {
      this.$refs.currentForm.validate(valid => {
        if (valid) {
          if (this.currentCompany.branch_no && this.currentCompany.branch_no.length > 5) {
            this.$message.error(this.$t('1254'))
            return false
          }
          if (this.currentCompany.postcode && this.currentCompany.postcode.length > 5) {
            this.$message.error(this.$t('1255'))
            return false
          }
          modifybase(this.currentCompany).then(res => {
            if (res && res.code === 1) {
              this.$message.success(res.message)
              // this.$s.set('currentCompany', this.currentCompany)
              this.currentSession()
              this.saveState = false
            }
          })
        }
      })
    },
    // 认证状态提交
    saveAudit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await saveAudit(this.form)
          this.$notify.success({
            title: this.$t('229'),
            message: this.$t('886')
          })
          window.location.reload()
        }
      })
    },
    uploadSuccess([val]) {
      if (val && val.object_url) this.currentCompany.logo_url = val.object_url
    },
    async currentSession() {
      const { data } = await currentSession()
      this.$store.dispatch('permission/setPermissionList', data.permissions)
      this.$store.dispatch('user/setUserInfo', data.user_info)
      this.$store.commit('user/COMPANY_INFO', data.company_info)
      this.$s.set('currentCompany', data.company_info)
      this.$s.set('userInfo', data.user_info)
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.tip {
  color: $ls;
}
.wrap {
  box-sizing: border-box;
}
.icon {
  cursor: pointer;
}
.by-content {
  min-height: 100%;
  padding-bottom: 40px;
  .by-content-body {
    position: relative;

    .modify-wrap {
      position: absolute;
      top: 12px;
      right: 0;
      z-index: 1;
    }
  }
}
.base-authentication {
  margin-top: 30px;
  .explain {
    opacity: 0.5;
    font-size: 14px;
  }
  .baseinfo-name {
    display: inline-block;
    width: calc(100% - 80px);
    padding: 7px 80px 0 20px;
    /deep/ .el-input {
      margin-top: 20px;
      width: 80%;
      max-width: 100%;
      input {
        height: 32px;
      }
    }
  }
  .audit-status {
    margin-bottom: 20px;
    font-size: 12px;
    opacity: 0.7;
  }
  .base-form-wrap {
    width: 50%;
    display: inline-block;
    .label-title {
      line-height: 40px;
    }
    /deep/ .el-select {
      max-width: 254px;
      width: 100%;
    }
    /deep/ .el-input {
      max-width: 254px;
      input {
        height: 32px;
      }
    }
  }
  .base-form-wrap-100 {
    width: 100%;
  }
}
.baseinfo-wrap {
  overflow: auto;
  position: relative;
  display: flex;
  .baseinfo-logo {
    width: 80px;
    height: auto;
    background: $menuText;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    float: left;
    cursor: pointer;
    &:hover {
      /deep/ .el-upload {
        opacity: 1 !important;
        background: rgba(0, 0, 0, 0.3);
      }
      .bottom-tip {
        opacity: 1;
      }
    }
    /deep/ .el-upload {
      position: absolute;
      left: 0;
      top: 0;
      width: 80px;
      height: 80px;
      background: transparent;
      opacity: 0;
      transition: all 0.3s;
      z-index: 10;
      .el-icon-plus {
        opacity: 0;
      }
    }
    > img {
      width: 100%;
      height: 100%;
    }
    .bottom-tip {
      position: absolute;
      transition: all 0.3s;
      height: 26px;
      opacity: 0.8;
      bottom: 0;
      left: 0;
      width: 100%;
      line-height: 26px;
      font-size: 12px;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
  .baseinfo-name {
    display: inline-block;
    width: calc(100% - 80px);
    padding: 7px 80px 0 20px;
    /deep/ .el-input {
      margin-top: 20px;
      width: 686px;
      max-width: 100%;
      input {
        height: 32px;
      }
    }
  }
}
.replace-manager {
  .by-list-title {
    line-height: 28px;
    height: 28px;
    margin: 20px 0;
  }
  .replace-tip {
    margin-bottom: 20px;
  }
  .current-manager {
    position: relative;
    height: 40px;
  }
  .current-list {
    display: inline-block;
    &:nth-child(1) {
      margin-right: 50px;
    }
  }
  .transfo {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.senior {
  p {
    line-height: 20px;
  }
}
</style>
